export const METRIKA_COUNTER = process.env.REACT_APP_METRIKA_COUNTER;
export const METRIKA_ENABLE = process.env.REACT_APP_ANALYTIC_ENABLE === 'true';
export const METRIKA_HOST = process.env.REACT_APP_METRIKA_HOST;
export const GTM_ID = process.env.REACT_APP_GTM_ID || null;

export const ENABLED_BASIC_AUTH = process.env.REACT_APP_ENABLED_BASIC_AUTH === 'true';
